import * as types from './LoginActionTypes';

export const setLogin = (loginstate) => {
    return {
        type: types.SET_LOGIN,
        payload: loginstate
    };
};

export const setUserid = (userId) => {
    return {
        type: types.SET_USERID,
        payload: userId
    };
};

export const setUserName = (userName) => {
    return {
        type: types.SET_USERNAME,
        payload: userName
    };
};

export const setLastName = (lastName) => {
    return {
        type: types.SET_LASTNAME,
        payload: lastName
    };
};

export const setEmail = (email) => {
    return {
        type: types.SET_EMAIL,
        payload: email
    };
};

export const setCompanyIds = (companyIds) => {
    return {
        type: types.SET_COMPANYIDS,
        payload: companyIds
    }
}

export const setUserToken = (userToken) => {
    return {
        type: types.SET_USERTOKEN,
        payload: userToken
    }
}

export const setUserRoles = (roles) => {
    return {
        type: types.SET_USERROLES,
        payload: roles
    }
}

export const setSubscriberUniqueId = (subscriberUniqueId) => {
    return {
        type: types.SET_SUBSCRIBERUNIQUEID,
        payload: subscriberUniqueId
    }
}

export const setIsSubscriberAdmin = (isSubscriberAdmin) => {
    return {
        type: types.SET_ISSUBSCRIBERADMIN,
        payload: isSubscriberAdmin
    }
}

export const setIsFlagstoneAdmin = (isFlagstoneAdmin) => {
    return {
        type: types.SET_ISFLAGSTONEADMIN,
        payload: isFlagstoneAdmin
    }
}